const RECAPTCHA_SITE_KEY = '6LdcBywsAAAAALBG_TzMfpxTVlgNYQfNwfNATkkC';
const RECAPTCHA_SCRIPT_SRC = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
const SCRIPT_SELECTOR = 'script[data-stc-recaptcha="v3"]';

let loadPromise: Promise<void> | null = null;

export const loadRecaptchaScript = async (): Promise<void> => {
  if (window.grecaptcha) {
    return;
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise<void>((resolve, reject) => {
    const existingScript = document.querySelector<HTMLScriptElement>(SCRIPT_SELECTOR);

    if (existingScript) {
      if (window.grecaptcha) {
        resolve();
        return;
      }

      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener('error', () => reject(new Error('captcha-not-loaded')), {
        once: true,
      });
      return;
    }

    const script = document.createElement('script');
    script.src = RECAPTCHA_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.setAttribute('data-stc-recaptcha', 'v3');
    script.addEventListener('load', () => resolve(), { once: true });
    script.addEventListener('error', () => reject(new Error('captcha-not-loaded')), { once: true });
    document.head.appendChild(script);
  }).finally(() => {
    if (!window.grecaptcha) {
      loadPromise = null;
    }
  });

  return loadPromise;
};
